import React, { useState } from 'react';
import './HelpIcon.css';

interface HelpIconProps {
	helpText: string;
	className?: string;
}

export const HelpIcon: React.FC<HelpIconProps> = ({ helpText, className }) => {
	const [isTooltipVisible, setIsTooltipVisible] = useState(false);

	const handleMouseEnter = () => {
		setIsTooltipVisible(true);
	};

	const handleMouseLeave = () => {
		setIsTooltipVisible(false);
	};

	const handleClick = () => {
		setIsTooltipVisible(!isTooltipVisible);
	};

	return (
		<div
			className={`help-icon-container ${className || ''}`}
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
			onClick={handleClick}
		>
			<svg
				className="help-icon"
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M10.8275 6.26731C10.9129 6.00704 10.9555 5.7152 10.9555 5.39051C10.9555 4.75904 10.723 4.26411 10.2579 3.90571C9.79243 3.54731 9.15883 3.36811 8.35712 3.36811C8.00725 3.36811 7.66123 3.39371 7.32075 3.44491C6.97899 3.49611 6.56896 3.59851 6.09152 3.75211L6.47509 5.21131C7.09845 4.98091 7.63989 4.86571 8.10112 4.86571C8.46805 4.86571 8.74923 4.93397 8.94549 5.07051C9.14261 5.20704 9.23989 5.40331 9.23989 5.65931C9.23989 5.78731 9.21899 5.90464 9.17589 6.01131C9.13365 6.11797 9.05856 6.23104 8.95232 6.35051C8.84565 6.46997 8.59179 6.70891 8.19072 7.06731C7.94325 7.28917 7.75339 7.49611 7.62112 7.68811C7.48843 7.88011 7.39712 8.096 7.34549 8.33451C7.29472 8.57344 7.26912 8.99157 7.26912 9.58891H8.72832C8.72832 9.29877 8.74795 9.06837 8.78635 8.89771C8.82432 8.72704 8.88832 8.57557 8.97749 8.44373C9.06752 8.31104 9.29536 8.08747 9.66272 7.77131C10.0292 7.46411 10.2942 7.20171 10.4563 6.98411C10.618 6.76651 10.7426 6.528 10.8275 6.26731ZM8.63317 12.3311C8.83755 12.131 8.93995 11.8895 8.93995 11.6079C8.93995 11.3267 8.83755 11.0857 8.63317 10.8847C8.42837 10.6846 8.18944 10.5843 7.91595 10.5843C7.64331 10.5843 7.40395 10.6846 7.19957 10.8847C6.99477 11.0857 6.89152 11.3267 6.89152 11.6079C6.89152 11.8895 6.99477 12.131 7.19957 12.3311C7.40395 12.5316 7.64331 12.6319 7.91595 12.6319C8.18944 12.6319 8.42837 12.5316 8.63317 12.3311ZM8 0C12.4186 0 16 3.58187 16 8C16 12.4186 12.4186 16 8 16C3.58187 16 0 12.4186 0 8C0 3.58187 3.58187 0 8 0Z"
					fill="#B0B0B0"
				/>
			</svg>
			{isTooltipVisible && <div className="help-tooltip">{helpText}</div>}
		</div>
	);
};

export default HelpIcon;
